import mascot from '@/pages/Schedule/pages/ScheduleMessages/components/EmptyState/mascot-text.png';
import { Flex, Heading, Image } from '@/ui';

export const MessagesEmptyState = () => (
  <Flex
    align="center"
    direction="column"
    mt={{ base: 8, lg: '60px' }}
    textAlign="center"
    w="100%"
  >
    <Image alt="" maxW="341px" src={mascot} w="100%" />
    <Heading fontSize={{ base: 'xl', md: '2xl', lg: '32px' }} fontWeight="bold">
      No text messages scheduled yet!
    </Heading>
  </Flex>
);
